import { format, parseISO } from 'date-fns';

export interface RosterAgentItem {
  userId: string;
  agentName: string;
  campaignName: string;
  clockedIn?: boolean;
  clockInTime?: string | null;
  clockInCampaignName?: string | null;
}

export interface VacationAgentRosterItem extends RosterAgentItem {
  startDate: string;
  endDate: string;
}

export interface RosterMetrics {
  activeAgentCount: number;
  dayOff: number;
  notScheduled: number;
  activeAgentsNote: string;
  dayOffAgents: RosterAgentItem[];
  notScheduledAgents: RosterAgentItem[];
  vacationAgents: VacationAgentRosterItem[];
}

export function formatRosterAgentLabel(
  agent: Pick<RosterAgentItem, 'agentName' | 'campaignName'>,
): string {
  return `${agent.agentName} (${agent.campaignName})`;
}

export function formatVacationAgentLabel(
  agent: Pick<VacationAgentRosterItem, 'agentName' | 'campaignName'>,
): string {
  return formatRosterAgentLabel(agent);
}

export function formatVacationDateRange(
  agent: Pick<VacationAgentRosterItem, 'startDate' | 'endDate'>,
): string {
  const start = format(parseISO(agent.startDate), 'MMM d');
  const end = format(parseISO(agent.endDate), 'MMM d');
  if (start === end) return start;
  return `${start} – ${end}`;
}
